import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";
import { errMsg } from "@/lib/api";
import { AuthShell, inputCls, btnCls } from "./Login";
import { GoogleButton } from "@/pages/AuthCallback";
import { PasswordInput } from "@/components/PasswordInput";

export default function Register() {
  const { t } = useT();
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", restaurant_name: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await register(f); nav("/app"); } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <AuthShell title={t("register")} footer={<>{t("have_account")} <Link to="/login" data-testid="go-login-link" className="font-semibold text-[#4a8a56]">{t("login")}</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="register-name-input" required placeholder={t("name")} className={inputCls} value={f.name} onChange={set("name")} />
        <input data-testid="register-restaurant-input" required placeholder={t("restaurant_name")} className={inputCls} value={f.restaurant_name} onChange={set("restaurant_name")} />
        <input data-testid="register-email-input" type="email" required placeholder={t("email")} className={inputCls} value={f.email} onChange={set("email")} />
        <PasswordInput testId="register-password-input" required minLength={6} placeholder={t("password")} value={f.password} onChange={set("password")} />
        <label className="flex items-start gap-2 text-xs text-slate-600">
          <input data-testid="register-terms-checkbox" type="checkbox" required className="mt-0.5 accent-[#5aa469]" />
          <span>{t("accept_terms_1")} <Link to="/legal/termini" target="_blank" className="font-semibold text-[#4a8a56] underline">{t("terms")}</Link> {t("accept_terms_2")} <Link to="/legal/privacy" target="_blank" className="font-semibold text-[#4a8a56] underline">{t("privacy_policy")}</Link></span>
        </label>
        {err && <p data-testid="register-error" className="text-sm text-rose-600">{err}</p>}
        <button data-testid="register-submit-btn" disabled={busy} className={btnCls}>{t("start_free")}</button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />{t("or")}<span className="h-px flex-1 bg-slate-200" /></div>
      <GoogleButton label={t("google_register")} />
    </AuthShell>
  );
}
